import client from '../client'

const PATH = '/feature-rules'

/**
 * Create a new feature rule. Please see the docs in the matcher api for more information.
 * @param {Object} body
 */
function create(body) {
  return client.post(PATH, body).then(({ data }) => data)
}


/**
 * Get the feature rules according to some parameters. See the matcher api docs for more information.
 * @param {Object} params the parameters to put in the query 
 */
function get(params) {
  return client.get(PATH, { params }).then(({ data }) => data)
}


/**
 * Remove a rule by its id.
 * @param {Number} id 
 */
function remove(id) {
  return client.delete(`${PATH}/${id}`)
}

export default {
  create,
  get,
  remove
}